module.exports = __webpack_public_path__ + "img/branding_upgrade_before.8961126.png";